import useAccount from "./useAccount";

/** True when the current account has an active contractor (contractor_id present and contractor_is_active) */
export const useIsActiveContractor = (): boolean => {
  const { account } = useAccount();
  return Boolean(
    account?.contractor_id !== undefined && account?.contractor_is_active,
  );
};
